export default {
  namespaced: true,

  state: {
    discountGroups: [],
  },

  getters: {
    getDiscountGroupById: (state) => (id) => {
      if (!id) {
        return undefined;
      }

      return state.discountGroups.find(
        (discountGroup) => discountGroup.id === id
      );
    },
    calculateTotalPriceWithDiscount: (state, getters) => (productPriceData) => {
      const mappedPrice = [];

      for (const data of productPriceData) {
        const discountPercentage = getters.getDiscountGroupById(
          data.discount_group
        );

        if (!discountPercentage) {
          mappedPrice.push({
            discounted_total_price: data.price,
          });
          continue;
        }

        if (discountPercentage.amount > 0) {
          const totalDiscount = (data.price * discountPercentage.amount) / 100;

          mappedPrice.push({
            discounted_total_price:
              data.price - totalDiscount > 0 ? data.price - totalDiscount : 0,
          });
        }
      }

      return mappedPrice.reduce(
        (acc, cur) => acc + cur.discounted_total_price,
        0
      );
    },
  },

  mutations: {
    setDiscountGroups(state, discountGroups) {
      if (!Array.isArray(discountGroups)) {
        return;
      }

      state.discountGroups = discountGroups;
    },
  },
};
